export default {
  organization: {},
  organizations: [],
  ministries: [],
}
